import {LocalizedDictionary} from '../Translator';

export default {
  "DD": "DD",
  "Discontinued": "Abandonné",
  "Spare part list": "Liste des pièces détachées",
  "Download Excel": "Télécharger Excel",
  "Recent search list": "Liste des recherches récentes",
  "No data": "Pas de données",
  "spare part": "pièce de rechange",
  "none": "aucun",
  "no value": "aucune valeur",
  "No results found": "Aucun résultat trouvé",
  "Spare parts for": "Pièces détachées pour",
  "Could not load cumulated data": "Impossible de charger les données cumulées",
  "commissioning part": "partie commissionnement",
  "wear part": "pièce d\u0027usure",
  "Search": "Recherche",
  "Tk": "Tk",
  "Spare part number": "Numéro de la pièce de rechange",
  "drawing": "dessin",
  "Products for": "Produits pour",
  "Available": "Disponible",
  "MM": "MM",
  "The entered order code is invalid": "Le code de commande saisi n\u0027est pas valide",
  "Recommended": "Recommandé",
  "No data available for the entered search parameters": "Aucune donnée disponible pour les paramètres de recherche saisis",
  "Search spare parts": "Recherche de pièces détachées",
  "Order code / product root / serial number": "Code de commande / racine du produit / numéro de série",
  "Characteristic": "Caractéristique",
  "Please enter an order code": "Veuillez saisir un code de commande",
  "Regarding quality- and security-aspects Endress+Hauser strongly recommends the exclusive use of genuine Endress+Hauser spare parts. The instrument may only be maintained and repaired by qualified personnel. The device documentation, applicable standards and legal requirements as well as any certificates have to be observed!": "En ce qui concerne la qualité et la sécurité, Endress+Hauser recommande vivement l\u0027utilisation exclusive de pièces de rechange Endress+Hauser d\u0027origine. \nL\u0027instrument ne peut être entretenu et réparé que par du personnel qualifié. \nLa documentation de l\u0027appareil, les normes et les exigences légales applicables ainsi que les certificats éventuels doivent être respectés !",
  "Maintenance advice": "Conseils d\u0027entretien",
  "Mo.": "Mo.",
  "For which product(s) can my spare part be used? Filling in the spare part order code (e.g. 71002865 or XPD0024) shows the relevant devices this spare part can be used in.": "Pour quel(s) produit(s) ma pièce détachée peut-elle être utilisée ? En remplissant le code de commande de la pièce de rechange (par exemple 71002865 ou XPD0024), vous verrez les appareils dans lesquels cette pièce de rechange peut être utilisée.",
  "tool": "outil",
  "Production numbers": "Chiffres de production",
  "New alternative": "Nouvelle alternative",
  "There are no items selected. Please use the checkboxes to make your selection": "Il n\u0027y a pas d\u0027éléments sélectionnés. Veuillez utiliser les cases à cocher pour faire votre sélection",
  "Service segmentation": "Segmentation des services",
  "Seg": "Seg",
  "Valid": "Valable",
  "Pos": "Pos",
  "Value": "Valeur",
  "service segmentation 2": "Pièces nécessitant des connaissances de base. Une participation réussie à la formation de base E+H est une condition préalable.",
  "Phase out date": "Date de retrait progressif",
  "service segmentation 1": "Pièces nécessitant des connaissances de base.",
  "Which spare parts are available for my product? Filling in the order code (e.g. FTC260-AA2A1 or PMC51-BA21JB1CGBTDJB) or the product id (e.g. FTC260 or 83F50) shows the relevant spare parts.": "Quelles sont les pièces détachées disponibles pour mon produit ? En remplissant le code de commande (par exemple FTC260-AA2A1 ou PMC51-BA21JB1CGBTDJB) ou l\u0027identifiant du produit (par exemple FTC260 ou 83F50), vous obtiendrez les pièces détachées correspondantes.",
  "Set filter": "Régler le filtre",
  "Search date": "Date de recherche",
  "Group": "Groupe",
  "Warning": "Avertissement",
  "Description": "Description",
  "Cancel": "Annuler",
  "service segmentation 4": "Pièces pour réparation en usine. Les connaissances spécialisées sont obligatoires.",
  "service segmentation 3": "Pièces nécessitant des connaissances spécialisées. Une participation réussie à la formation avancée d\u0027E+H est une condition préalable.",
  "Drawing Position Number": "Numéro de position du dessin",
  "Spare parts search": "Recherche de pièces détachées",
  "Confirm": "Confirmer",
  "Ordercode too short": "Code de commande trop court",
  "Product status": "Statut du produit",
  "Open": "Ouvrir",
  "Clear": "Clair",
  "PDF file with assembly instructions": "Fichier PDF avec instructions de montage",
  "Search products": "Recherche de produits",
  "Export": "Exportation",
  "Production date": "Date de production",
  "Order stop": "Arrêt de la commande",
  "Calibration until": "Calibrage jusqu\u0027à",
  "PDF file with compatibility information": "Fichier PDF avec des informations sur la compatibilité",
  "Add selection to cart": "Ajouter la sélection au panier",
  "Mounting advices": "Conseils de montage",
  "Recommended parts only": "Pièces recommandées uniquement",
  "not applicable": "sans objet",
  "accessories": "accessoires",
  "Cumulative spare parts list": "Liste cumulative des pièces de rechange",
  "YYYY": "YYYY",
  "Title": "Titre",
  "Error": "Erreur",
  "Ordercode too long": "Code de commande trop long",
  "Functions": "Fonctions",
  "Rec": "Rec",
  "Type": "Type",
  "Spare sensor until": "Capteur de rechange jusqu\u0027à",
  "Spare parts until": "Pièces de rechange jusqu\u0027à",
  "Filter": "Filtre",
  "Check all": "Tout vérifier",
  "Order code": "Code de commande",
  "Repair until": "Réparation jusqu\u0027à",
  "Tag": "Étiquette",
  "Ok": "Ok",
  "Category code": "Code de la catégorie",
  "Phase out": "Suppression progressive",
  'Compatibility advices': 'Documents supplémentaires',
  'Co.': 'Doc. suppl.',
} as LocalizedDictionary;
